import { Box } from '@mui/material';
import { Assessment } from '@schooly/api';
import { useAuth } from '@schooly/components/authentication';
import { AssessmentStatuses } from '@schooly/constants';
import { SelectedIds } from '@schooly/utils/bulk-actions';
import { mobileDetect } from '@schooly/utils/mobile';
import { FC } from 'react';

import { GridContainer } from '../Grid/Grid';
import { ListViewAssessmentsRow } from '../ListViewAssessmentsRow/ListViewAssessmentsRow';

const MD_BREAKPOINT_TABLE_MIN_WIDTH = 600;

export interface ListViewAssessmentsProps {
  groupId?: string;
  assessments: Assessment[];
  onSelectAssessment?: (v: string) => void;
  selectedIds?: SelectedIds;
}

export const ListViewAssessments: FC<ListViewAssessmentsProps> = ({
  groupId,
  assessments,
  onSelectAssessment,
  selectedIds,
}) => {
  const { permissions } = useAuth();
  const isMobile = mobileDetect.mobile();

  return (
    <Box
      sx={(theme) => ({
        [theme.breakpoints.down('md')]: {
          overflowX: 'scroll',
        },
      })}
    >
      <GridContainer
        sx={(theme) => ({
          overflow: 'visible',
          [theme.breakpoints.down('md')]: {
            minWidth: MD_BREAKPOINT_TABLE_MIN_WIDTH,
            overflowY: 'hidden',
            py: 0.5,
          },
        })}
      >
        {assessments.map((assessment) => {
          const canEdit =
            permissions.includes('assessment_manager') &&
            assessment.status !== AssessmentStatuses.Published &&
            !assessment.autogenerated;

          return (
            <ListViewAssessmentsRow
              key={assessment.id}
              assessment={assessment}
              path={`/assessments/${assessment.id}${groupId ? `?group_id=${groupId}` : ''}`}
              canEdit={canEdit}
              onSelect={onSelectAssessment}
              isSelected={selectedIds === 'all' || !!selectedIds?.has(assessment.id)}
              showActions={Boolean(isMobile)}
            />
          );
        })}
      </GridContainer>
    </Box>
  );
};
